import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/components/download/download.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/components/lifestyle-pop/lifestyle-pop.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/components/slideshow/slideshow.jsx");
